import React, { useState, useEffect } from 'react';
import userProfile from '../../Images/Logo/default-profile.png';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import { getCurrentUserDetail, getUserDocId, isLoggedIn } from '../../Localstorage';
import { fetchDownloadImg, fetchStudentData, updateUserData } from '../../Firebase/User-fb';
import { useNavigate } from 'react-router-dom';
import Editprofileskeleton from '../../Helper/Editprofileskeleton';
import Toast from '../../Notification/Toast';

const Editprofile = () => {
  const { toggleProfile, setToast } = useAccessCard();
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUserData = async () => {
      setLoading(true);
      if (isLoggedIn()) {
        const student_docId = getUserDocId();
        const userDatas = await fetchStudentData(student_docId);

        if (userDatas) {
          setUserData({
            ...userDatas,
            address: userDatas.address || {
              pin_code: '',
              line1: '',
              locality: '',
              city: '',
              state: ''
            }
          });
        } else {
          console.error('User data not found.');
        }
      }
      setLoading(false);
    };

    loadUserData();
  }, []);

  const sanitizeValue = (value) =>
    ["", "NA", null, undefined].includes(value) ? "" : value;

  const formatDateForInput = (dateStr) => {
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  };

  const formatDateToDDMMYYYY = (dateStr) => {
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      address: {
        ...prev.address,
        [name]: value,
      },
    }));
  };

  const handleBirthdayChange = (e) => {
    const value = formatDateToDDMMYYYY(e.target.value);
    setUserData((prev) => ({
      ...prev,
      birthday: value,
    }));
  };

  const handleProfileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const url = await fetchDownloadImg(file);
    setUserData((prev) => ({
      ...prev,
      student_image: url,
    }));
  };

  const updateStudentData = () => {
    if (isLoggedIn()) {
      const student_docId = getUserDocId();
      if (updateUserData(student_docId, userData)) {
        toggleProfile();
        showToast('Profile updated successfully', 'success')
        navigate("/");
      } else {
        console.log('error');
      }
    }
  };

  const showToast = (msg, type) => {
    setToast({ message: msg, type });
  };

  if (loading) return <Editprofileskeleton />;

  const filledFields = Object.values(userData).filter(
    (val) => typeof val === 'string' && val.trim() !== '' && val !== "NA"
  ).length;
  const progress = Math.round((filledFields / 15) * 100);

  return (
    <div className="edit-profile-container">
      <span onClick={toggleProfile} className="profile-close-card">X</span>
      <h2>Edit Profile</h2>

      <div className="profile-pic">
        <img src={userData.student_image || userProfile} alt="profile" />
        <label htmlFor="profileUpload" className="edit-icon">✏️</label>
        <input
          id="profileUpload"
          type="file"
          style={{ display: 'none' }}
          onChange={handleProfileUpload}
        />
      </div>

      <p>{progress}% Profile Complete</p>
      <div className="progress-bar">
        <div className="progress" style={{ width: `${progress}%` }}></div>
      </div>

      <div className="profile-card">
        <div className="profile-card-one">
          <form className="profile-form">
            <h3 className="profile-head">Personal Detail</h3>

            <div className="input-wrapper">
              <input type="text" name="name" value={sanitizeValue(userData.name)} onChange={handleChange} placeholder=" " />
              <label>Full Name</label>
            </div>

            <div className="input-wrapper">
              <input type="text" name="mobile_number" value={sanitizeValue(userData.mobile_number)} onChange={handleChange} placeholder=" " />
              <label>Mobile Number</label>
            </div>

            <div className="input-wrapper">
              <input type="text" name="student_wp_number" value={sanitizeValue(userData.student_wp_number)} onChange={handleChange} placeholder=" " />
              <label>WhatsApp Number (optional)</label>
            </div>

            <div className="input-wrapper">
              <input type="email" name="student_email" value={sanitizeValue(userData.student_email)} onChange={handleChange} placeholder=" " />
              <label>Email ID</label>
            </div>

            <div className="input-wrapper">
              <input type="text" name="guardian_full_name" value={sanitizeValue(userData.guardian_full_name)} onChange={handleChange} placeholder=" " />
              <label>Guardian's Name (optional)</label>
            </div>

            <div className="input-wrapper">
              <input
                type="date"
                name="birthday"
                value={userData.birthday ? formatDateForInput(userData.birthday) : ''}
                onChange={handleBirthdayChange}
                placeholder=" "
              />
              <label>Birthday (optional)</label>
            </div>

            <div className="form-group">
              <label className="profile-head">Married (Optional)</label>
              <div className="button-group">
                <button
                  type="button"
                  className={userData.is_married === true ? 'selected' : ''}
                  onClick={() => setUserData((prev) => ({ ...prev, is_married: true }))}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className={userData.is_married === false ? 'selected' : ''}
                  onClick={() => setUserData((prev) => ({ ...prev, is_married: false }))}
                >
                  No
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="profile-card-two">
          <h3 className="profile-head">Academic Details (optional)</h3>
          <div className="form-group">
            <label className="profile-head">Select Highest Education</label>
            <div className="button-group">
              <button
                type="button"
                className={userData.highest_degree === 'Graduation' ? 'selected' : ''}
                onClick={() => setUserData((prev) => ({ ...prev, highest_degree: 'Graduation' }))}
              >
                Graduation
              </button>
              <button
                type="button"
                className={userData.highest_degree === 'Masters' ? 'selected' : ''}
                onClick={() => setUserData((prev) => ({ ...prev, highest_degree: 'Masters' }))}
              >
                Masters
              </button>
            </div>
          </div>

          <div className="input-wrapper" style={{ marginTop: '20px' }}>
            <input
              type="text"
              name="college_name"
              value={sanitizeValue(userData.college_name)}
              onChange={handleChange}
              placeholder=" "
            />
            <label>College/ University Name</label>
          </div>
        </div>

        <div className="profile-card-two">
          <form className="profile-form">
            <h3 className="profile-head">Address (optional)</h3>

            <div className="input-wrapper">
              <input type="text" name="pin_code" value={sanitizeValue(userData.address.pin_code)} onChange={handleAddressChange} placeholder=" " />
              <label>Pin code</label>
            </div>

            <div className="input-wrapper">
              <input type="text" name="line1" value={sanitizeValue(userData.address.line1)} onChange={handleAddressChange} placeholder=" " />
              <label>Address Line</label>
            </div>

            <div className="input-wrapper">
              <input type="text" name="locality" value={sanitizeValue(userData.address.locality)} onChange={handleAddressChange} placeholder=" " />
              <label>Locality</label>
            </div>

            <div className="input-wrapper">
              <input type="text" name="city" value={sanitizeValue(userData.address.city)} onChange={handleAddressChange} placeholder=" " />
              <label>Town/City</label>
            </div>

            <div className="input-wrapper">
              <input type="text" name="state" value={sanitizeValue(userData.address.state)} onChange={handleAddressChange} placeholder=" " />
              <label>State</label>
            </div>
          </form>
        </div>
      </div>

      <button className="profile-form-button" type="submit" onClick={updateStudentData}>Save Changes</button>
    </div >
  );
};

export default Editprofile;
